/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

/*
	* type组件类型，
	section:段落,
	text:正文文本,
	image:图片,
	annotation:, 注释文本
	video:视频,
	url:跳转链接, 
	plug: 充电点,
	vote:投票
*/
const { apiPath } = require('appService/api');
const ajaxHttp = require('appUtil/ajaxHttp');
const template = require('./viewModule.tpl');
require('./viewModule.scss');

const moduleView = {
	template,
	props:{
		type:{
			type:String,
			default:""
		},
		detailData:{
			type:Object,
			default: () => {}
		}
	},
	data(){
		return{
			detailUrl: apiPath.charge.spotDetail,
			spotTypeList:['未知','慢速','快速','','超速'],
			spotData:{},
			isWechat: /micromessenger/.test(navigator.userAgent.toLowerCase()),
      iOS: /ip(hone|ad|od)/.test(navigator.userAgent.toLowerCase()),
      android : /android/.test(navigator.userAgent.toLowerCase()),
      isdownapp:/chargerlink/.test(navigator.userAgent.toLowerCase())
		}
	},
	ready(){
		this._init();
	},
	methods:{
		_init(){
			if(this.detailData.type=='plug'){
				ajaxHttp(this.detailUrl,{
          data:{
            spotID:this.detailData.spotId
            }
          })
          .then((rtn) => {
            let data =rtn.data;

            this.spotData = data;

            })
			}
		},
		formatText(text){
      return (text+'').replace(/\n/g,'<br/>')
    },
    loadURL(url){
       var iFrame;
       iFrame =document.createElement("iframe");
       iFrame.setAttribute("src", url);
       iFrame.setAttribute("style","display:none;");
       iFrame.setAttribute("height", "0px");
       iFrame.setAttribute("width", "0px");
       iFrame.setAttribute("frameborder", "0");
       document.body.appendChild(iFrame);
       iFrame.parentNode.removeChild(iFrame);
       iFrame = null;
    },
    goPlug(){
    	let _spotId = this.detailData.spotId || '';
    	if(this.isdownapp){
    		this.loadURL("cl://spot/?id="+_spotId);
    	}else{
    		window.location.href="http://appshare.platform.chargerlink.com/site?id="+_spotId;
    		//this.$route.router.go({name:'previewPlugDetail',params:{id:_spotId}});
    	}
    }
	},
	filters:{
		filterNetType(type){
			let netType = {
				"0": "未联网",
				"1": "已联网"
			}
			return netType[type]
		},
		filterType(type) {
			let typeList = {
				"0": "个人",
				"1": "公共",
				"2": "运营"
			}
			return `${typeList[type]}站点`
		},
		filterPileNum(num) {
			return `${num}个电桩`
		},
	}
}

module.exports = moduleView;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/preview/viewModule/viewModule.js